import { usePermission } from "core/hooks/usePermission";

export function useCanEditNewsEventArticle() {
  const hasBasePermission = usePermission("NewsEvents.Articles.Edit");
  // other permission logic?
  return hasBasePermission;
}
